/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsFeedbackForm = {
  init: function($section) {
    var _this = this;
    $('.feedback-btn').click(this.toggleFeedbackModal.bind(this));
    $('.feedback-overlay-bg').click(this.toggleFeedbackModal.bind(this));
    $('button.feedback-cta-btn.btn-close-form').click(this.toggleFeedbackModal.bind(this));

    $('.feedback-radio input[name="contact[Feedback type]"]').change(function() {
     var $this = $(this),
         value = $this.val().toLowerCase();
     _this.toggleFeedbackTpl(value)
    })

    $('.feedback-radio input[name="contact[Prefer contact type]"]').change(function() {
     var $this = $(this),
         value = $this.val().toLowerCase();
     _this.toggleFeedbackResponseTpl(value);
    })
    $(document).on('keyup change','.feedback-form-input', function() {
     var $this = $(this),
         value = $this.val(),
         indicator = $this.parent().find('.length-indicator #current-length');
     indicator.text(value.length)
    })
    $(document).on('click','.range-selection .feedback-range', function() {
     var $this = $(this),
         value = $this.data('value');
     _this.addBgToRange(value)
    })

    $('.f-popup-bg').click(this.toggleFeedbackNotif);

    window.toggleThankyouNotice = function() {
     var $notifBanner = $('.feedback-ty-popup');

     $notifBanner.fadeToggle();
    }

    var alreadySubmitted = Cookies.get('feedback_submitted') === 'true' ? true : false;

    function getParameterByName(name, url = window.location.href) {
     name = name.replace(/[\[\]]/g, '\\$&');
     var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
         results = regex.exec(url);
     if (!results) return null;
     if (!results[2]) return '';
     return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    window.addEventListener('load', e => {
     if(location.hash !== '#ContactForm' && getParameterByName('contact_posted') !== 'true' && !alreadySubmitted) {
       setTimeout(function() {
         _this.toggleFeedbackNotif()
       }, 3000)
     }
    });
  },
  toggleFeedbackModal: function() {
   var modal = $('.feedback-main-content'),
       bg = $('.feedback-overlay-bg'),
       btn = $('button.feedback-btn');

   this.toggleFeedbackNotif('hide');
   modal.fadeToggle();
   bg.fadeToggle();
   btn.fadeToggle(function() {
     $('html, body').toggleClass('scroll-hidden');
   });
 },

 addBgToRange: function(value) {
  var ranges = $('.range-selection .feedback-range')

  for(var i = 0; i <= value; i++) {
    ranges.eq(i).addClass('range-on-action')
  }
  for(var a = value + 1; a > value && a < ranges.length; a++) {
    ranges.eq(a).removeClass('range-on-action')
  }
},

 toggleFeedbackTpl: function(value) {
  var container = $('.feedback-main-inputs'),
      tpl = feedbackTpl[value];

  container.empty();
  container.append(tpl)
  $('.feedback-prefer-contact').show();
},

  toggleFeedbackResponseTpl: function(value) {
  var container = $('.feedback-contact-preferences'),
      tpl = feedbackTpl[value];

  container.empty();
  container.append(tpl)
},

 toggleFeedbackNotif: function(action) {
  var $notifBanner = $('.feedback-popup')

  if(action === 'hide') {
    $notifBanner.fadeOut();
  }else {
    $notifBanner.fadeToggle();
  }
 }
}

/******/ })()
;
